<div class="container">
    <div class="category-listing neo-scrollbar">
        <div class="neo-tabs">
            <div class="neo-tab" [class.active]="isAllActive" (click)="openCategory('All')">
                All Emails
            </div>
            <!-- @for (item of [1,2,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,43,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4]; track $index) {
            <div class="neo-tab" [class.active]="isAllActive" (click)="openCategory('All')">
                All Emails
            </div>
            } -->
            @for (category of categories; track $index) {
            <div class="neo-tab" (click)="openCategory(category.name)" [class.active]="category.isActive">
                @if (!category.isRenameCategory || category.is_default) {
                    {{category.name}}
                } @else {
                    <div class="category-container">
                        <p >
                            <span class="p-inputgroup renameCategory">
                                <input type="text" pInputText placeholder="Rename" [(ngModel)]="categoryRename"
                                    (keyup.enter)="renameCategory(category)" (click)="$event.preventDefault(); $event.stopPropagation();" 
                                    style="max-width: 158px !important;margin: 0 !important;height: 36px !important;">
                                <div class="renameCategory-button">
                                    <em class="pi pi-check rename-action_icon" (click)="$event.preventDefault(); $event.stopPropagation(); renameCategory(category)"></em>
                                    <em class="pi pi-times rename-action_icon" (click)="$event.preventDefault(); $event.stopPropagation(); category.isRenameCategory = false;"></em>
                                </div>
                            </span>
                        </p>
                    </div>
                }

                @if(!category.is_default) {
                @if(!category.isRenameCategory) {
                <em class="pi pi-ellipsis-v category-edit" [class.show]="options_op.overlayVisible" #categoryEdit
                    (click)="$event.preventDefault(); $event.stopPropagation(); togglePanel($event, options_op);"></em>
                }
                <p-popover #options_op [dismissable]="true" styleClass="no-padding-overlay">
                    <ng-template #content>
                        <p class="categoryOptions-overlay" *ngIf="userPrivileges.has('email_category.delete')"
                            (click)="deleteCategory(category, $event)">
                            Delete</p>
                        <p class="categoryOptions-overlay " *ngIf="userPrivileges.has('email_category.update')"
                            (click)="category.isRenameCategory = true; categoryRename = category.name; options_op.hide()">
                            Rename</p>
                    </ng-template>
                </p-popover>
                }
            </div>
            }
            <div class="" *ngIf="userPrivileges.has('email_category.create')">
                <p-inplace #ip [style]="{'min-height':'33px'}"
                    class="link">
                    <ng-template pTemplate="display">
                        <div class="add-template">
                            <i class="pi pi-plus-circle"></i>
                            Add New Category
                        </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <span class="p-inputgroup newCategory">
                            <input type="text" pInputText placeholder="Category Name" [(ngModel)]="newCategoryName">
                            <button type="button" pButton pRipple icon="pi pi-check" styleClass="p-button-warn"
                                (click)="addCategory(ip)" *ngIf="newCategoryName.length"></button>
                            <button type="button" pButton pRipple icon="pi pi-times" styleClass="p-button-warn"
                                (click)="ip.deactivate($event);" *ngIf="!newCategoryName.length"></button>
                        </span>
                    </ng-template>
                </p-inplace>
            </div>
        </div>
    </div>
    <div class="content">
        <div class="template-main-content">
            <div class="side-nav">
                @if (isLoading ) {
                <div class="neo-tabs vertical neo-scrollbar">
                    @for (ske of [1,2,3,4,5]; track $index) {
                    <div class="neo-tab">
                        <p-skeleton height="32px"></p-skeleton>
                    </div>
                    }
                </div>
                } @else {
                @if (_templateList.length) {
                <div class="neo-tabs vertical neo-scrollbar">
                    @for (template of _templateList; track template.id) {
                    <div class="neo-tab" [class.active]="openedTemplate()?.id === template.id" (click)="openTemplate(template)">
                        {{template.templateTitle}}
                    </div>
                    }
                </div>
                } @else {
                <empty-state *ngIf="!isLoading">
                    <empty-state-title>No Templates Found</empty-state-title>
                    <empty-state-subtitle>Create a template by clicking on "Create New Template".</empty-state-subtitle>
                </empty-state>
                }
                }
            </div>
            <div class="template-details">
                <div class="template-content neo-scrollbar">
                    @if (isLoading || loadingTemplateDetails) {
                    <div style="width: 100%; height: 100%;" class="center-loader">
                        <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
                        </p-progressSpinner>
                    </div>
                    } @else {
                    @if (openedTemplate()) {
                    <div class="template-header">
                        Template Details
                    </div>
                    <div class="template-details-content">
                        <div class="neo-grid neo-grid-cols-2">
                            <div class="neo-input-wrapper">
                                <label for="template_name" required>Template Name</label>
                                <input pInputText type="text" name="template_name" id="template_name"
                                    [readOnly]="!userPrivileges.has('email_template.update') || (openedTemplate()?.is_default ?? false)" [(ngModel)]="editingTemplateName" (ngModelChange)="disableSaveChanges.set(false)">
                            </div>
                            <div class="neo-input-wrapper">
                                <label for="template_category" required>Category</label>
                                <p-select class="dropdown" inputId="dropdown" [autoDisplayFirst]="false" optionLabel="name" optionValue="id"
                                    [options]="categories" [(ngModel)]="editingTemplateCategory"
                                    [disabled]="!userPrivileges.has('email_template.update') || (openedTemplate()?.is_default ?? false)" (ngModelChange)="disableSaveChanges.set(false)">
                                </p-select>
                            </div>
                        </div>
                        <div class="neo-grid neo-grid-cols-1">
                            <div class="neo-input-wrapper">
                                <label for="template_subject" required>Subject</label>
                                <input pInputText type="text" name="template_subject" id="template_subject" [(ngModel)]="editingTemplateSubject"
                                    [readOnly]="!userPrivileges.has('email_template.update')" (ngModelChange)="disableSaveChanges.set(false)">
                            </div>
                        </div>
                        <div class="neo-grid neo-grid-cols-1">
                            <div class="neo-input-wrapper">
                                <div style="display: flex;" [class.mb]="editingTemplate()">
                                    <label for="template_message" required style="flex: 1">Message</label>
                                    @if (!editingTemplate() && userPrivileges.has('email_template.update')) {
                                    <span class="label-action" (click)="editOpenedTemplate(true);">Edit</span>
                                    }
                            
                                    @if(editingTemplate()) {
                                    <div style="display: flex; gap: 20px;">
                                        <span class="label-action" (click)="op.hide(); showPlaceholder = true" (mouseenter)="op.toggle($event)"
                                            (mouseleave)="op.hide()" label="Add Placeholder">Add Placeholder</span>
                                        <span class="label-action" (click)="editOpenedTemplate(false)">Close</span>
                                        <!-- <p-dialog header="Add Placeholder" [(visible)]="showPlaceholder" class="placeholder-dialog" position="topright"
                                            [style]="{position: 'fixed', top: '7.875rem', margin: '0 20px', maxWidth: '33.5vw', minWidth: '30vw'}">
                                            <p-chip *ngFor="let item of placeholders" label="{{item.tag}}" (click)="insertPlaceholder(item.value)">
                                            </p-chip>
                                        </p-dialog> -->
                                        <p-popover #op styleClass="no-padding-overlay">
                                            <ng-template #content>
                                                <div
                                                    [style]="{display: 'flex', width: '310px', padding: '10px 16px', boxShadow: '0px 2px 14px rgba(0, 0, 0, 0.06)'}">
                                                    <em class="info-button"></em>
                                                    <p [style]="{overflowWrap: 'break-word', color: 'var(--fc-dark)', padding: '2px'}">Set
                                                        placeholders to customize your email templates automatically.</p>
                                                </div>
                                            </ng-template>
                                        </p-popover>
                                    </div>
                                    }
                                </div>
                                @if (!editingTemplate()) {
                                <div style="pointer-events: none;" [innerHTML]="openedTemplate()?.templateContent | getSafeHTMLEmail"></div>
                                } @else {
                                <textarea placeholder="Template Description" id="content"></textarea>
                                }
                            </div>
                        </div>
                    </div>
                    } @else {
                        <empty-state *ngIf="!isLoading && !loadingTemplateDetails">
                            <empty-state-title>No Templates Found</empty-state-title>
                            <empty-state-subtitle>Create a template by clicking on "Create New Template" or select a template from the list of available templates.</empty-state-subtitle>
                        </empty-state>
                    }
                    }
                </div>
                 @if (openedTemplate() && (userPrivileges.has('email_template.delete') || userPrivileges.has('email_template.update'))) {
                <div class="template-footer">
                    <button class="delete-btn" *ngIf="userPrivileges.has('email_template.delete')"
                        [disabled]="openedTemplate()?.is_default ?? false"
                        [pTooltip]="(openedTemplate()?.is_default ?? false) ? 'This is a default template. It cannot be deleted.' : ''"
                        tooltipPosition="top"
                        (click)="deleteTemplate(openedTemplate()!, $event)" id="delete_template_btn">
                        Delete
                    </button>
                    <button class="create-btn" *ngIf="userPrivileges.has('email_template.update')"
                        [disabled]="disableSaveChanges() || saveBtnLoading" pButton [loading]="saveBtnLoading"
                        (click)="updateTemplate()" id="update_template_btn">
                        Save Changes
                    </button>
                </div>
                }
            </div>
        </div>
    </div>

    <p-confirmpopup></p-confirmpopup>
</div>

<p-dialog header="Add Template" [(visible)]="addTemplateSidebar" [modal]="true" [closable]="true" [draggable]="false"
    [resizable]="false" (onHide)="addTemplateForm.reset(); showPlaceholder = false;templateToEdit = '';selectedCategoryId = '';placeholders = [];">

    <div [formGroup]="addTemplateForm" style="width: 50vw;" *ngIf="addTemplateSidebar">
        <div class="dialog-content">
            <div class="neo-grid neo-grid-cols-2">
                <div class="neo-input-wrapper">
                    <label for="title" required>Template Name</label>
                    <input type="text" class="title" id="title" pInputText formControlName="templateTitle"
                        [ngClass]="{'invalid': clicked && addTemplateForm.controls['templateTitle'].errors}" placeholder="Template Title">
                    <app-handle-error [clicked]="clicked" [control]="addTemplateForm.get('templateTitle')" name="Title">
                    </app-handle-error>
                </div>
                <div class="neo-input-wrapper">
                    <label for="category" required>Category</label>
                    <p-select big class="dropdown" inputId="category" [autoDisplayFirst]="false" optionLabel="name" [options]="categories"
                        formControlName="category" [required]="true" optionValue="id"
                        [styleClass]="clicked && addTemplateForm.controls['category'].errors ? 'invalid' : ''" placeholder="Category"
                        (onChange)="onDialogCategoryChange($event.value)">
                    </p-select>
                    <app-handle-error [clicked]="clicked" [control]="addTemplateForm.get('category')"
                        name="Category"></app-handle-error>
                </div>
            </div>
            <div class="neo-input-wrapper">
                <label for="subject" required>Subject</label>
                <input type="text" id="subject" (click)="getElement('title')" pInputText
                    (keyup)="getElement('title')" formControlName="subjectTitle"
                    (focusout)="removeFocus()" [ngClass]="{'invalid': clicked && addTemplateForm.controls['subjectTitle'].errors}">
                <app-handle-error [clicked]="clicked" [control]="addTemplateForm.get('subjectTitle')"
                    name="Subject"></app-handle-error>
            </div>
            <div class="neo-input-wrapper">
                <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1vh;">
                    <label for="subject" required style="width: fit-content;">
                        Message
                    </label>
                    <span class="label-action" (click)="op.hide(); showPlaceholder = true" (mouseenter)="op.toggle($event)"
                        (mouseleave)="op.hide()" label="Add Placeholder">Add Placeholder</span>
                </div>
                <textarea *ngIf="addTemplateSidebar" placeholder="Template Description" id="content"></textarea>
            </div>
        </div>
        <div class="dialog-action">
            <button pButton pRipple type="submit" label="Create" (click)="saveTemplate()" class="create-btn"
                [loading]="saveBtnLoading"></button>
        </div>
    </div>

    <p-popover #op styleClass="no-padding-overlay">
        <ng-template #content>
            <div
                [style]="{display: 'flex', width: '310px', padding: '10px 16px', boxShadow: '0px 2px 14px rgba(0, 0, 0, 0.06)'}">
                <em class="info-button"></em>
                <p [style]="{overflowWrap: 'break-word', color: 'var(--fc-dark)', padding: '2px'}">Set
                    placeholders to customize your email templates automatically.</p>
            </div>
        </ng-template>
    </p-popover>
</p-dialog>

<p-dialog header="Add Placeholder" [draggable]="false" [(visible)]="showPlaceholder" class="placeholder-dialog" position="topright"
    [modal]="true" [closable]="true"
    [style]="{position: 'fixed', top: '7.875rem', margin: '0 20px', maxWidth: '42vw', minWidth: '40vw', 'max-height': '300px'}" [baseZIndex]="9999">
    <p-chip *ngFor="let item of placeholders" label="{{item.tag}}" (click)="insertPlaceholder(item.value)">
    </p-chip>
</p-dialog>

<!-- <div *ngIf="isLoading" class="loadingOverlay">
    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
    </p-progressSpinner>
</div> -->
<p-toast></p-toast>
<p-confirmpopup></p-confirmpopup>